/* Shadeday · comportement de la fiche produit (sections/sd-product.liquid).
   Galerie, pastilles « teinte principale », offres (1 / 3 / 5 bouteilles), une teinte par bouteille, livraison,
   ajout au panier groupé par variante via window.SD.addToCart, accordéons exclusifs, barre collante,
   et écoute de l'événement `sd:select-shade` émis par les cartes de la section teintes (sd-squad).

   Règles des teintes :
   - les pastilles appliquent la teinte à TOUTES les bouteilles (et montrent la teinte de la bouteille 1) ;
   - chaque menu « Bottle N » ne change que sa bouteille ; la bouteille 1 pilote la galerie et l'URL ?variant= ;
   - changer d'offre conserve les choix déjà faits (tableau de bouteilles de la taille de la plus grosse offre).
   Prix d'un lot = remise « achète X, reçois Y gratuit » : les `free` bouteilles les moins chères sont offertes
   (prix de la variante dans la devise affichée, marchés à prix fixes compris) ; en repli (free = 0) montant fixe
   discount_line converti au taux du marché. Barré = somme des prix barrés. Montants formatés par SD.money (devise du marché). */
(function () {
  'use strict';
  var NS = (window.SD = window.SD || {});
  if (NS.__productLoaded) return; /* la section peut être deux fois sur une page : écouteurs du document une seule fois */
  NS.__productLoaded = true;

  var roots = []; /* fiches initialisées, dans l'ordre du document : la première reçoit sd:select-shade */

  function money(cents) {
    if (window.SD && typeof window.SD.money === 'function') return window.SD.money(cents);
    return ((Number(cents) || 0) / 100).toFixed(2); /* sd.js absent : montant sans symbole plutôt qu'une devise fausse */
  }

  /* Résout avec SD.addToCart dès que le module sd-cart.js est prêt ; rejette après un délai (repli : envoi natif du formulaire). */
  function whenCartReady(timeout) {
    return new Promise(function (resolve, reject) {
      if (window.SD && typeof window.SD.addToCart === 'function') return resolve(window.SD.addToCart);
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; reject(new Error('sd-cart-timeout')); } }, timeout || 6000);
      document.addEventListener('sd:cart:ready', function () {
        if (done) return;
        done = true; clearTimeout(t);
        if (window.SD && typeof window.SD.addToCart === 'function') resolve(window.SD.addToCart);
        else reject(new Error('sd-cart-timeout'));
      }, { once: true });
    });
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) c++;
    }
    return d;
  }

  function fmtDate(d, locale, opts) {
    try { return d.toLocaleDateString(locale || 'en-US', opts); }
    catch (e) { return d.toDateString(); }
  }

  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim(); }

  function onCleanup(root, fn) { (root.__sdpCleanup = root.__sdpCleanup || []).push(fn); }
  function destroy(root) {
    if (!root) return;
    (root.__sdpCleanup || []).forEach(function (fn) { try { fn(); } catch (e) { /* rien */ } });
    root.__sdpCleanup = [];
    var i = roots.indexOf(root);
    if (i >= 0) roots.splice(i, 1);
  }

  function init(root) {
    if (!root || root.__sdpInit) return;
    var jsonEl = root.querySelector('[data-sdp-json]');
    root.__sdpInit = true;
    initGallery(root);
    initAccordions(root);
    if (!jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;
    data.offers = Array.isArray(data.offers) ? data.offers : [];
    var L = data.labels || {};
    var locale = data.locale && data.locale.indexOf('-') < 0 ? data.locale + '-US' : data.locale;
    if (locale && !/^en/i.test(locale)) locale = data.locale;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    function findVariant(id) {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === Number(id)) return data.variants[i];
      return null;
    }
    function firstAvailable() {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].available) return data.variants[i];
      return null;
    }
    function tpl(str, key, val) { return String(str || '').split(key).join(val); }

    var start = findVariant(data.selected) || firstAvailable() || data.variants[0];
    var maxQty = Math.max(1, Number(data.maxQty) || 1);
    data.offers.forEach(function (o) { maxQty = Math.max(maxQty, Number(o.qty) || 1); });
    var state = {
      offer: typeof data.defaultOffer === 'number' ? data.defaultOffer : 0,
      qty: 1,
      main: start.id,
      bottles: []
    };
    for (var b = 0; b < maxQty; b++) state.bottles.push(start.id);

    var form = $('[data-sdp-form]');
    var atc = $('[data-sdp-atc]');
    var atcLabel = $('[data-sdp-atc-label]');
    var atcTotal = $('[data-sdp-atc-total]');
    var atcAmount = $('[data-sdp-atc-amount]');
    var errorEl = $('[data-sdp-error]');
    var sticky = $('[data-sdp-sticky]');
    var stickyBtn = $('[data-sdp-sticky-btn]');
    var offerCards = $$('[data-sdp-offer]');
    var qtyInput = $('[data-sdp-qty]');
    var shadeInputs = $$('[data-sdp-shade-input]');
    var shadeName = $('[data-sdp-shade-name]');
    var panel = $('[data-sdp-bottles]');
    var list = panel ? panel.querySelector('[data-sdp-bottle-list]') : null;
    var lineTpl = $('[data-sdp-bottle-tpl]');
    var busy = false;

    function currentOffer() { return data.offers.length ? data.offers[state.offer] || data.offers[0] : null; }
    function currentQty() { var o = currentOffer(); return o ? Math.max(1, Number(o.qty) || 1) : state.qty; }

    /* Variantes des n premières bouteilles (sans offre : la teinte principale × quantité). */
    function idsFor(n) {
      var out = [];
      for (var i = 0; i < n; i++) out.push(data.multi && data.offers.length ? (state.bottles[i] || state.main) : state.main);
      return out;
    }

    function calc(offer) {
      var n = offer ? Math.max(1, Number(offer.qty) || 1) : state.qty;
      var ids = idsFor(n);
      var prices = [], sum = 0, cmp = 0, sellable = true;
      ids.forEach(function (id) {
        var v = findVariant(id) || start;
        prices.push(v.price);
        sum += v.price;
        cmp += Math.max(v.compare || 0, v.price);
        if (!v.available) sellable = false;
      });
      var disc = 0;
      var free = offer ? Math.max(0, Math.min(n - 1, Math.round(Number(offer.free) || 0))) : 0;
      if (free > 0) {
        /* « achète X, reçois Y gratuit » : Shopify offre les articles les moins chers du lot */
        prices.slice().sort(function (a, b) { return a - b; }).slice(0, free).forEach(function (p) { disc += p; });
      } else if (offer && offer.line > 0) {
        /* repli : montant fixe dans la devise de la boutique, converti au taux du marché comme Shopify */
        var rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
        disc = Math.round(offer.line * rate);
      }
      var total = Math.max(0, sum - disc);
      return { n: n, ids: ids, total: total, unit: n ? total / n : 0, compare: cmp, save: cmp - total, sellable: sellable };
    }

    function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
    function toggle(el, show) { if (el) el.hidden = !show; }

    function render() {
      var c = calc(currentOffer());

      /* rangée de prix */
      setText($('[data-sdp-price-now]'), money(c.total));
      var was = $('[data-sdp-price-was]');
      setText(was, money(c.compare));
      toggle(was, c.save > 0);
      var pctEl = $('[data-sdp-price-save]');
      var pct = c.compare > 0 ? Math.round((c.save / c.compare) * 100) : 0;
      if (pctEl) {
        setText(pctEl, tpl(L.savePct, '[percent]', pct));
        toggle(pctEl, c.save > 0 && pct > 0);
      }

      /* cartes d'offre */
      offerCards.forEach(function (card) {
        var i = Number(card.getAttribute('data-sdp-offer'));
        var o = data.offers[i];
        if (!o) return;
        var oc = calc(o);
        setText(card.querySelector('[data-sdp-offer-total]'), money(oc.total));
        var cmpEl = card.querySelector('[data-sdp-offer-cmp]');
        setText(cmpEl, money(oc.compare));
        toggle(cmpEl, oc.save > 0);
        var each = card.querySelector('[data-sdp-offer-each]');
        if (each) { setText(each, tpl(L.each, '[price]', money(oc.unit))); toggle(each, oc.n > 1); }
        var sv = card.querySelector('[data-sdp-offer-save]');
        if (sv) { setText(sv, tpl(L.save, '[amount]', money(oc.save))); toggle(sv, oc.save > 0); }
        var selected = i === state.offer;
        card.classList.toggle('is-selected', selected);
        var input = card.querySelector('[data-sdp-offer-input]');
        if (input && input.checked !== selected) input.checked = selected;
      });

      /* bouton d'achat */
      if (atc) {
        atc.disabled = !c.sellable;
        setText(atcLabel, c.sellable ? (L.atc || '') : (L.soldout || ''));
        setText(atcAmount, money(c.total));
        toggle(atcTotal, c.sellable && !!L.atc);
      }

      /* barre collante */
      if (sticky) {
        setText(sticky.querySelector('[data-sdp-sticky-now]'), money(c.total));
        var sw = sticky.querySelector('[data-sdp-sticky-was]');
        setText(sw, money(c.compare));
        toggle(sw, c.save > 0);
        var ssv = sticky.querySelector('[data-sdp-sticky-save]');
        if (ssv) { setText(ssv, '-' + pct + '%'); toggle(ssv, pct > 0); }
        if (stickyBtn) {
          stickyBtn.disabled = !c.sellable;
          setText(sticky.querySelector('[data-sdp-sticky-label]'), c.sellable ? (L.sticky || L.atc || '') : (L.soldout || ''));
        }
      }
    }

    /* Pastilles : cochent la teinte principale (= bouteille 1) */
    function renderShades() {
      shadeInputs.forEach(function (inp) {
        var on = Number(inp.value) === Number(state.main);
        if (inp.checked !== on) inp.checked = on;
      });
      var mv = findVariant(state.main);
      if (shadeName && mv) setText(shadeName, mv.title);
    }

    function bottleLabel(i) { return tpl(L.bottle || 'Bottle [n]', '[n]', i + 1); }

    function setDot(line, id) {
      var dot = line.querySelector('[data-sdp-bottle-dot]');
      var v = findVariant(id);
      if (!dot) return;
      if (v && v.swatch) { dot.style.setProperty('--sdp-sw', v.swatch); dot.classList.remove('is-none'); }
      else { dot.style.removeProperty('--sdp-sw'); dot.classList.add('is-none'); }
    }

    function makeLine(i) {
      var src = lineTpl && lineTpl.content && lineTpl.content.querySelector('[data-sdp-bottle]');
      if (!src) return null;
      var li = src.cloneNode(true);
      li.setAttribute('data-sdp-bottle', String(i));
      var sel = li.querySelector('[data-sdp-bottle-select]');
      var lab = li.querySelector('label');
      if (sel) sel.id = sel.id.split('__I__').join(String(i));
      if (lab) { lab.setAttribute('for', sel ? sel.id : ''); lab.textContent = bottleLabel(i); }
      return li;
    }

    /* Panneau des bouteilles : sous l'offre choisie, une ligne par bouteille (masqué pour 1 bouteille) */
    function renderBottles() {
      if (!panel || !list) return;
      var o = currentOffer();
      var n = currentQty();
      var show = !!(data.multi && o && n > 1);
      var host = root.querySelector('[data-sdp-offer="' + state.offer + '"]');
      if (host && panel.parentNode !== host) host.appendChild(panel);
      panel.hidden = !show;
      if (!show) return;
      var lines = Array.prototype.slice.call(list.querySelectorAll('[data-sdp-bottle]'));
      for (var i = lines.length; i < n; i++) {
        var li = makeLine(i);
        if (li) { list.appendChild(li); lines.push(li); }
      }
      lines.forEach(function (line, k) {
        if (k >= n) { line.remove(); return; }
        var sel = line.querySelector('[data-sdp-bottle-select]');
        var want = String(state.bottles[k] || state.main);
        if (sel && sel.value !== want) sel.value = want;
        setDot(line, want);
      });
    }

    function showVariantMedia(id) {
      var v = findVariant(id);
      if (v && v.media && root.__sdpGoToMedia) root.__sdpGoToMedia(v.media);
    }

    function updateUrl(id) {
      if (!data.updateUrl || !window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) { /* rien */ }
    }

    /* Teinte principale : applyAll = toutes les bouteilles (pastilles, section teintes) ; sinon bouteille 1 seulement */
    function setMain(id, applyAll) {
      id = Number(id);
      if (!findVariant(id)) return;
      state.main = id;
      if (applyAll) { for (var i = 0; i < state.bottles.length; i++) state.bottles[i] = id; }
      else state.bottles[0] = id;
      renderShades();
      renderBottles();
      render();
      showVariantMedia(id);
      updateUrl(id);
    }

    /* Nom de teinte → variante : égalité (titre ou option), sinon correspondance partielle unique */
    function matchShade(name) {
      var n = norm(name);
      if (!n) return null;
      var exact = data.variants.filter(function (v) {
        return norm(v.title) === n || (v.options || []).some(function (o) { return norm(o) === n; });
      });
      var pool = exact.length ? exact : data.variants.filter(function (v) {
        var t = norm(v.title);
        return t.indexOf(n) >= 0 || n.indexOf(t) >= 0;
      });
      if (!pool.length || (!exact.length && pool.length > 1)) return null;
      for (var i = 0; i < pool.length; i++) if (pool[i].available) return pool[i];
      return pool[0];
    }

    root.__sdpSelectShade = function (name) {
      var v = data.multi ? matchShade(name) : null;
      if (v) setMain(v.id, true);
      var target = $('[data-sdp-shades]') || $('[data-sdp-offers]') || form;
      if (target && window.SD && typeof window.SD.scrollToEl === 'function') window.SD.scrollToEl(target, 96);
      else if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target) {
        target.classList.remove('sdp-flash');
        setTimeout(function () { target.classList.add('sdp-flash'); setTimeout(function () { target.classList.remove('sdp-flash'); }, 1600); }, 450);
      }
    };

    /* Lignes du panier, regroupées par variante (3 bouteilles Black, Black, Dark Brown → 2 lignes) */
    function lines() {
      var c = calc(currentOffer());
      if (!c.sellable) return [];
      var byId = {}, order = [];
      c.ids.forEach(function (id) {
        if (!byId[id]) { byId[id] = 0; order.push(id); }
        byId[id] += 1;
      });
      return order.map(function (id) { return { id: Number(id), quantity: byId[id] }; });
    }

    function writeFormLines(items) {
      var box = $('[data-sdp-lines]');
      if (!box) return;
      box.innerHTML = '';
      items.forEach(function (it) {
        ['id', 'quantity'].forEach(function (k) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'items[][' + k + ']';
          inp.value = String(k === 'id' ? it.id : it.quantity);
          box.appendChild(inp);
        });
      });
    }

    function setBusy(on, btn) {
      busy = on;
      [atc, stickyBtn].forEach(function (b2) {
        if (!b2) return;
        b2.classList.toggle('is-loading', on && b2 === btn);
        if (on) b2.setAttribute('aria-busy', 'true'); else b2.removeAttribute('aria-busy');
      });
      render();
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function add(btn) {
      if (busy) return;
      var items = lines();
      if (!items.length) return;
      showError('');
      setBusy(true, btn);
      whenCartReady(6000)
        .then(function (addToCart) { return addToCart(items, btn); })
        .then(function () { setBusy(false); })
        .catch(function (err) {
          if (!root.isConnected) return;
          if (err && err.message === 'sd-cart-timeout' && form) {
            writeFormLines(items);
            form.submit();
            return;
          }
          setBusy(false);
          showError((err && (err.sdUserMessage || err.message)) || '');
        });
    }

    // ---- événements
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(atc); });

    /* La barre collante ne met pas au panier : elle remonte aux offres + bouton d'achat, puis fait pulser le bouton. */
    function goToBuy() {
      var target = atc || $('[data-sdp-offers]');
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var h = target ? target.getBoundingClientRect().height : 0;
      var off = Math.max(96, vh - h - 28);
      if (window.SD && typeof window.SD.scrollToEl === 'function') window.SD.scrollToEl(target, off);
      else if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
      if (atc) {
        atc.classList.remove('sdp-pulse');
        setTimeout(function () { atc.classList.add('sdp-pulse'); setTimeout(function () { atc.classList.remove('sdp-pulse'); }, 1900); }, 650);
      }
    }
    if (stickyBtn) stickyBtn.addEventListener('click', goToBuy);

    $$('[data-sdp-offer-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        state.offer = Number(input.value);
        renderBottles();
        render();
      });
    });

    shadeInputs.forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) setMain(inp.value, true); });
    });

    if (panel) {
      panel.addEventListener('change', function (e) {
        var sel = e.target && e.target.closest && e.target.closest('[data-sdp-bottle-select]');
        if (!sel) return;
        var line = sel.closest('[data-sdp-bottle]');
        var i = line ? Number(line.getAttribute('data-sdp-bottle')) : -1;
        if (!(i >= 0)) return;
        var id = Number(sel.value);
        state.bottles[i] = id;
        setDot(line, id);
        if (i === 0) {
          state.main = id;
          renderShades();
          showVariantMedia(id);
          updateUrl(id);
        }
        render();
      });
    }

    if (qtyInput) {
      var clampQty = function (n) { return Math.max(1, Math.min(99, parseInt(n, 10) || 1)); };
      qtyInput.addEventListener('change', function () { state.qty = clampQty(qtyInput.value); qtyInput.value = state.qty; render(); });
      var minus = $('[data-sdp-qty-minus]');
      var plus = $('[data-sdp-qty-plus]');
      if (minus) minus.addEventListener('click', function () { state.qty = clampQty(state.qty - 1); qtyInput.value = state.qty; render(); });
      if (plus) plus.addEventListener('click', function () { state.qty = clampQty(state.qty + 1); qtyInput.value = state.qty; render(); });
    }

    // ---- livraison (heure locale du visiteur)
    var ship = $('[data-sdp-ship]');
    if (ship) {
      var today = new Date();
      var min = Math.max(0, Number(data.shipMin) || 0);
      var max = Math.max(min, Number(data.shipMax) || 0);
      var opts = { weekday: 'short', month: 'short', day: 'numeric' };
      var a = fmtDate(addBusinessDays(today, min), locale, opts);
      var z = fmtDate(addBusinessDays(today, max), locale, opts);
      setText(ship.querySelector('[data-sdp-eta]'), a === z ? a : a + ' – ' + z);
    }

    // ---- barre collante : visible une fois le bouton d'achat dépassé, masquée sur l'appel final / le pied de page
    if (sticky && atc && 'IntersectionObserver' in window) {
      var pastAtc = false;
      var endVisible = false;
      var update = function () {
        var show = pastAtc && !endVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      var atcIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastAtc = !en.isIntersecting && en.boundingClientRect.top < 0; });
        update();
      }, { threshold: 0 });
      atcIo.observe(atc);
      onCleanup(root, function () { atcIo.disconnect(); });

      var ends = Array.prototype.slice.call(document.querySelectorAll('.sd-final-cta, .sd-footer, footer, .shopify-section-group-footer-group'));
      if (ends.length) {
        var visibleSet = new Set();
        var endIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) visibleSet.add(en.target); else visibleSet.delete(en.target); });
          endVisible = visibleSet.size > 0;
          update();
        }, { threshold: 0 });
        ends.forEach(function (el) { endIo.observe(el); });
        onCleanup(root, function () { endIo.disconnect(); });
      }
    }

    // ---- état initial : lien ?variant= explicite → la galerie montre cette teinte (sinon on garde l'image 1)
    try {
      var asked = new URL(window.location.href).searchParams.get('variant');
      if (asked && Number(asked) === Number(start.id) && start.media && root.__sdpGoToMedia) root.__sdpGoToMedia(start.media, false);
    } catch (e) { /* rien */ }

    renderShades();
    renderBottles();
    render();
    roots.push(root);
    roots.sort(function (x, y) { return x.compareDocumentPosition(y) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-sdp-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-sdp-slide]'));
    var n = slides.length;
    var prev = root.querySelector('[data-sdp-prev]');
    var next = root.querySelector('[data-sdp-next]');
    var gotos = Array.prototype.slice.call(root.querySelectorAll('[data-sdp-goto]'));
    var thumbsBox = root.querySelector('.sdp-thumbs');
    var current = 0;
    var target = -1;
    var targetTimer = 0;

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(n - 1, i));
      target = i;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = -1; }, 700);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      current = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      gotos.forEach(function (btn) {
        var on = Number(btn.getAttribute('data-sdp-goto')) === i;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current');
        if (on && thumbsBox && btn.parentNode === thumbsBox) {
          var l = btn.offsetLeft - thumbsBox.offsetLeft;
          if (l < thumbsBox.scrollLeft || l + btn.offsetWidth > thumbsBox.scrollLeft + thumbsBox.clientWidth) {
            thumbsBox.scrollTo({ left: l - 8, behavior: 'smooth' });
          }
        }
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var idx = Math.max(0, Math.min(n - 1, Math.round(Math.abs(track.scrollLeft) / w)));
        if (target >= 0) { if (idx !== target) return; target = -1; }
        if (idx !== current) setActive(idx);
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    gotos.forEach(function (btn) { btn.addEventListener('click', function () { goTo(Number(btn.getAttribute('data-sdp-goto'))); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    root.__sdpGoToMedia = function (mediaId, smooth) {
      for (var i = 0; i < slides.length; i++) {
        if (Number(slides[i].getAttribute('data-media-id')) === Number(mediaId)) { if (i !== current) goTo(i, smooth); return; }
      }
    };

    var onResize = function () { track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' }); };
    window.addEventListener('resize', onResize, { passive: true });
    onCleanup(root, function () { window.removeEventListener('resize', onResize); clearTimeout(targetTimer); });
  }

  function initAccordions(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-sdp-acc]'));
    all.forEach(function (acc) {
      var btn = acc.querySelector('[data-sdp-acc-btn]');
      var inner = acc.querySelector('.sdp-acc__inner');
      if (!btn) return;
      function set(open) {
        acc.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (inner) { if (open) inner.removeAttribute('inert'); else inner.setAttribute('inert', ''); }
      }
      btn.addEventListener('click', function () {
        var willOpen = btn.getAttribute('aria-expanded') !== 'true';
        /* un seul accordéon ouvert à la fois : ouvrir celui-ci referme les autres */
        if (willOpen) all.forEach(function (other) { if (other !== acc && other.__sdpSet) other.__sdpSet(false); });
        set(willOpen);
      });
      acc.__sdpSet = set;
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-sdp]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Cartes de la section teintes : « Choose Black » → la première fiche de la page choisit la teinte et remonte aux offres */
  document.addEventListener('sd:select-shade', function (e) {
    var name = e && e.detail ? e.detail.shade : '';
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].isConnected && typeof roots[i].__sdpSelectShade === 'function') { roots[i].__sdpSelectShade(name); return; }
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-sdp]');
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-sdp]');
    if (el) destroy(el);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var acc = e.target && e.target.closest && e.target.closest('[data-sdp-acc]');
    if (acc && acc.__sdpSet) acc.__sdpSet(true);
    var offer = e.target && e.target.closest && e.target.closest('[data-sdp-offer]');
    if (offer) {
      var input = offer.querySelector('[data-sdp-offer-input]');
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
})();
